import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import './styles/global.css';
import App from './App';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Installable PWA: the service worker precaches the app shell only — live
// Firestore/Storage/Functions calls are cross-origin and bypass it entirely.
// New builds activate silently and take effect on the next reload.
if (import.meta.env.PROD) {
  registerSW({ immediate: true });
}
